/**
 * This is not automatically generated.
 */

export enum PriceModel {
	Standard = 0,
	Slow = 1,
	Express = 2,
}

export default {
	allPriceModels: [
		{
			value: PriceModel.Standard,
			name: "Schnell",
		},
		{
			value: PriceModel.Slow,
			name: "Preiswert",
		},
		{
			value: PriceModel.Express,
			name: "Express",
		},
	],
	getPriceModelText: (value: PriceModel) => {
		switch (value) {
			case PriceModel.Standard:
				return "Standard";
			case PriceModel.Express:
				return "Express";
			case PriceModel.Slow:
				return "Preiswert";
			default:
				return "Nicht verfügbar";
		}
	},
};
